import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from '@denishussar/html5-game-engine';
import { GameLogic } from '../../../Logic/GameLogic';
import { Point } from 'pixi.js';
import { LaserModel } from '../../../Models/MiniGames/LaserModel';

export interface ILaserMirrorControllerOptions {
    index: number;
    onSelected: (index: number) => void;
    onUnselected: (index: number) => void;
}

export class LaserMirrorController extends AnimationBaseController {
    $model: LaserModel;

    private _draggable: boolean = false;
    private _draggablePoint: Point;
    private _initialPoint: Point;

    public constructor(
        @Inject private _options: ILaserMirrorControllerOptions,
        @Inject private _gameLogic: GameLogic,
    ) {
        super('LaserMirrorController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            onPointerDown: e => {
                if (!this._draggable) {
                    this._draggable = true;
                    this._draggablePoint = e.localPosition.clone();

                    if (this._options.onSelected) {
                        this._options.onSelected(this._options.index);
                    }
                }
            },
            onPointerOver: () => {
                this.gotoAndStop('hover');
            },
            onPointerOut: () => {
                this.gotoAndStop('active');
            },
            onPointerUp: () => {
                if (this._draggable) {
                    if (this._options.onUnselected) {
                        this._options.onUnselected(this._options.index);
                    }
                    this._draggable = false;
                    this._draggablePoint = null;

                    this.gotoAndStop('active');
                }
            },
            onPointerUpOutside: () => {
                if (this._draggable) {
                    if (this._options.onUnselected) {
                        this._options.onUnselected(this._options.index);
                    }
                    this._draggable = false;
                    this._draggablePoint = null;

                    this.gotoAndStop('active');
                }
            },
            onPointerMove: e => {
                if (this._draggable) {
                    this.x += e.localPosition.x - this._draggablePoint.x;
                    this.y += e.localPosition.y - this._draggablePoint.y;

                    this._draggablePoint = e.localPosition.clone();
                }
            }
        };
    }

    protected onInitialize(): void {
        this._initialPoint = this.display.position.clone();
    }

    public toPlace(x: number, y: number): void {
        this.x = x;
        this.y = y;

        this.display.interactive = false;
        this.display.visible = false;
    }

    public toInitial(): void {
        this.display.position.copy(this._initialPoint);
    }
}
